import React from "react";
import { Box, Typography } from "@mui/material";

const Dashboarddesign = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        p: 3
      }}
    >
      <Typography variant="h6" sx={{ color: "#94a3b8", fontWeight: 500 }}>
        Welcome to Designer Portal. Please select a menu from the sidebar.
      </Typography>
    </Box>
  );
};

export default Dashboarddesign;